// get data to display on details page
export function getLanguages(data) {
  const lang = data?.acf?.reader_profile_description_languages;

  const keys = Object.keys(lang);
  const filtered = keys.filter((key) => lang[key]);
  return filtered.map((e) => {
    const split = e.split('_');
    return split[split.length - 1];
  });
}
